export const groupingOptions = [
    { value: 'none', label: 'All (No Grouping)' },
    { value: 'brand', label: 'Brand' },
    { value: 'division', label: 'By Division' },
    { value: 'consumer', label: 'Consumer' },
    { value: 'custom', label: 'Custom Groups' },
    { value: 'fieldOfPlay', label: 'Field of Play' },
    { value: 'franchise', label: 'Franchise' },
    { value: 'model', label: 'Model' }
];
